// ── 계약상품 미선택 확인 팝업 ─────────────────────────────────────────────────
// ContractModal.jsx(281줄)에서 떼어냄(2026-10-15, 300줄 규칙 — 4단계 계약 통합 4-1). 화면·동작은 그대로 —
//   닫기 = onCancel(전 setNoProductConfirm(false)), 저장 = onConfirm(전 doSave).
import React from 'react';

export function NoProductConfirm({ onCancel, onConfirm }) {
  return (
    <div
      onClick={onCancel}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 2100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: 'var(--bg-card)', borderRadius: 12, padding: '24px 28px', maxWidth: 340, width: '90%', boxShadow: '0 8px 32px rgba(0,0,0,0.25)', display: 'flex', flexDirection: 'column', gap: 16 }}
      >
        <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text)' }}>계약상품 미선택</div>
        <div style={{ fontSize: 13, color: 'var(--text-sub)', lineHeight: 1.6 }}>
          계약상품이 선택되지 않았습니다.<br />이대로 저장하시겠습니까?
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{ padding: '7px 18px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg-subtle)', color: 'var(--text-sub)', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}
          >
            취소
          </button>
          <button
            onClick={onConfirm}
            style={{ padding: '7px 18px', borderRadius: 8, border: 'none', background: '#2563eb', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}
          >
            저장
          </button>
        </div>
      </div>
    </div>
  );
}
